module.exports = __webpack_public_path__ + "img/HappyMan.e4793456.png";